<div class="form-row">
  <div class="form-group col-md-6">
    <label>Name</label>
    <input type="text" name='name' [(ngModel)]='this.productGroup.name' [class.is-invalid]='!this.productGroup.name' class="form-control">
  </div>
  <div class="form-group col-md-6">
    <label>Code</label>
    <input type="text" name='code' [(ngModel)]='this.productGroup.code' [class.is-invalid]='!this.productGroup.code' class="form-control">
  </div>
  <div class="form-group col-md-12">
    <label>Description</label>
    <textarea name='description' [(ngModel)]="this.productGroup.description" class="form-control"></textarea>
  </div>
</div>
